// Reading time in milliseconds for a content article
export const ARTICLE_READ_TIME = 20000;
